var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_547_9850)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7812 38.7076L27.82 29.9487H42.18L46.2188 38.7076H23.7812Z",
    fill: "#2297FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_547_9850",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3549 29.5969C30.5989 31.4356 32.4806 33.4269 35.0001 35.5708C37.5195 33.4269 39.4012 31.4356 40.6453 29.5969C41.8893 27.7582 42.5113 26.0564 42.5113 24.4916C42.5113 22.1443 41.7563 20.2743 40.2462 18.8816C38.7361 17.4888 36.9874 16.7925 35.0001 16.7925C33.0127 16.7925 31.264 17.4888 29.7539 18.8816C28.2438 20.2743 27.4888 22.1443 27.4888 24.4916C27.4888 26.0564 28.1108 27.7582 29.3549 29.5969Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3549 29.5969C30.5989 31.4356 32.4806 33.4269 35.0001 35.5708C37.5195 33.4269 39.4012 31.4356 40.6453 29.5969C41.8893 27.7582 42.5113 26.0564 42.5113 24.4916C42.5113 22.1443 41.7563 20.2743 40.2462 18.8816C38.7361 17.4888 36.9874 16.7925 35.0001 16.7925C33.0127 16.7925 31.264 17.4888 29.7539 18.8816C28.2438 20.2743 27.4888 22.1443 27.4888 24.4916C27.4888 26.0564 28.1108 27.7582 29.3549 29.5969Z",
    fill: "#2297FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 35.5708L34.352 36.3323L35.0001 36.8838L35.6481 36.3323L35.0001 35.5708ZM29.3549 29.5969L30.1831 29.0365H30.1831L29.3549 29.5969ZM40.6453 29.5969L39.817 29.0365V29.0365L40.6453 29.5969ZM40.2462 18.8816L40.9242 18.1465L40.2462 18.8816ZM29.7539 18.8816L29.0759 18.1465L29.7539 18.8816ZM35.6481 34.8092C33.1674 32.6982 31.3582 30.7734 30.1831 29.0365L28.5266 30.1573C29.8396 32.0979 31.7939 34.1556 34.352 36.3323L35.6481 34.8092ZM39.817 29.0365C38.6419 30.7734 36.8327 32.6982 34.352 34.8092L35.6481 36.3323C38.2062 34.1556 40.1605 32.0979 41.4735 30.1573L39.817 29.0365ZM41.5113 24.4916C41.5113 25.7892 40.9941 27.2968 39.817 29.0365L41.4735 30.1573C42.7845 28.2196 43.5113 26.3237 43.5113 24.4916H41.5113ZM39.5683 19.6167C40.8429 20.7922 41.5113 22.3797 41.5113 24.4916H43.5113C43.5113 21.9089 42.6697 19.7563 40.9242 18.1465L39.5683 19.6167ZM35.0001 17.7925C36.727 17.7925 38.236 18.3879 39.5683 19.6167L40.9242 18.1465C39.2363 16.5897 37.2478 15.7925 35.0001 15.7925V17.7925ZM30.4319 19.6167C31.7641 18.3879 33.2731 17.7925 35.0001 17.7925V15.7925C32.7523 15.7925 30.7638 16.5897 29.0759 18.1465L30.4319 19.6167ZM28.4888 24.4916C28.4888 22.3797 29.1572 20.7922 30.4319 19.6167L29.0759 18.1465C27.3304 19.7563 26.4888 21.9089 26.4888 24.4916H28.4888ZM30.1831 29.0365C29.006 27.2968 28.4888 25.7892 28.4888 24.4916H26.4888C26.4888 26.3237 27.2156 28.2196 28.5266 30.1573L30.1831 29.0365Z",
    fill: "black",
    mask: "url(#path-3-inside-1_547_9850)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.0001,
    cy: 24.7027,
    rx: 2.32381,
    ry: 2.32381,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_547_9850",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_547_9850"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_547_9850",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMapIcon);
export default __webpack_public_path__ + "static/media/ic_map_icon.b5419bb64565a8bc2cfb3f9ca07d4c5b.svg";
export { ForwardRef as ReactComponent };